import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppModule } from './app/app.module'
import { Constants } from 'config'

if (!Constants.ENV.isDevelopment) {
  enableProdMode()
}

export function main(): Promise<any> {
  return platformBrowserDynamic().bootstrapModule(AppModule)
}

if (document.readyState == 'complete') {
  main();
} else {
  document.addEventListener('DOMContentLoaded', main)
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./main.ts